import type { SkillAgent, SkillTeam } from '../../../shared/types';

interface UserLike {
  email: string;
  isAdmin?: boolean;
  roles?: string[];
}

export function canViewSkill(user: UserLike | null, skill: SkillAgent): boolean {
  if (!user) return false;
  if (skill.visibility === 'public') return true;
  if (user.isAdmin) return true;
  if (skill.visibility === 'team') {
    const userTeam = getUserTeam(user);
    return (
      skill.ownerTeam === userTeam ||
      skill.allowedTeams.includes(userTeam as SkillTeam)
    );
  }
  if (skill.visibility === 'restricted') {
    return skill.allowedUsers.includes(user.email);
  }
  return false;
}

export function canUseSkill(user: UserLike | null, skill: SkillAgent): boolean {
  return canViewSkill(user, skill);
}

export function canEditSkill(user: UserLike | null, skill: SkillAgent): boolean {
  if (!user) return false;
  if (user.isAdmin) return true;
  return skill.authorEmail === user.email;
}

export function canRestoreVersion(user: UserLike | null, skill: SkillAgent): boolean {
  return canEditSkill(user, skill);
}

// Maps Cognito role → SkillTeam for "Por equipo" tab
const ROLE_TO_TEAM: Record<string, SkillTeam> = {
  tech: 'Tech',
  finance: 'Finance',
  people: 'People',
  growth: 'Growth',
  admin: 'Tech',
};

export function getUserTeam(user: UserLike | null): SkillTeam | null {
  if (!user?.roles) return null;
  for (const role of user.roles) {
    if (ROLE_TO_TEAM[role]) return ROLE_TO_TEAM[role];
  }
  return null;
}
